import { PzTerm, PzUserSignUp } from 'models';

export class PzSource {
  private terms: PzTerm[];

  public constructor() {
    this.terms = [];
  }

  public async getPartnerizeTerms(locale: string, country: string) {
    const localeCountry = await this.checkLocaleCountry(locale, country);
    const terms = await this.loadPartnerizeTerms(localeCountry);

    return terms.partnerize;
  }

  public async getExpediaGroupTerms(locale: string, country: string) {
    const localeCountry = await this.checkLocaleCountry(locale, country);
    const terms = await this.loadPartnerizeTerms(localeCountry);

    return terms.expediagroup;
  }

  private async checkLocaleCountry(locale: string, country: string) {
    // check locale is in a valid list
    // check country is in a valid list
    return `${locale}/${country}`;
  }

  private async loadPartnerizeTerms(localeCountry: string) {
    if (!this.terms[localeCountry]) {
      await fetch(`/api/v1/pz/reference/terms/${localeCountry}`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((localeData) => {
          const terms = {
            partnerize: {},
            expediagroup: {},
          };

          for (const termItem of localeData.terms) {
            switch (termItem.term.tnc_type) {
              case 'entity':
                terms.partnerize = termItem.term;
                break;
              case 'network':
                terms.expediagroup = termItem.term;
                break;
            }
          }

          // tslint:disable-next-line:no-console
          console.log('PZ T&Cs retrieved for ', localeCountry);

          this.terms[localeCountry] = terms;
        })
        .catch((error) => {
          // tslint:disable-next-line:no-console
          console.log('Could not retrieve PZ T&Cs for ', localeCountry, error);
        });
    } else {
      // tslint:disable-next-line:no-console
      console.log('CACHED PZ T&Cs retrieved for ', localeCountry);
    }

    return this.terms[localeCountry];
  }

  public async createUser(programName: string, user: PzUserSignUp) {
    let resOk = false;
    let resStatusText = null;

    // Create the user + partner on PZ
    return await fetch('/api/v1/pz/user/', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ user }),
    })
      .then((response) => {
        resOk = response.ok;
        resStatusText = response.statusText;

        return response.json();
      })
      .then((createUserData) => {
        if (createUserData.success === false) {
          return createUserData;
        } else {
          const partnerId = createUserData.partnerId;
          const campaignRequest = {
            programName,
            campaignTermsId: user.campaignTermsId,
          };

          // Assign the user to the requested campaign on PZ
          return fetch(`/api/v1/pz/user/${partnerId}/campaign`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(campaignRequest),
          })
            .then((campaignResponse) => {
              return campaignResponse.json();
            })
            .then((assignCampaignData) => {
              return {
                success: true,
                error: null,
                body: assignCampaignData,
              };
            })
            .catch((error) => {
              return {
                success: false,
                error,
                body: null,
              };
            });
        }
      });
  }
}
